import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { RollUpInitiativeIcon } from './RollUpInitiativeIcon';
import { RollUpInitiativeName } from './RollUpInitiativeName';

export class RollUpInitiativeFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [RollUpInitiativeIcon, RollUpInitiativeName];
  }

  get title() {
    return terminology('Features');
  }
}
